<div class="dialog-container">
  <div class="dialog-header">
    <span class="main-text">
      <!-- <span class="material-icons warning-icon">warning</span> -->
      Confirm Delete
    </span>
  </div>
  <div class="dialog-content">
    <span class="sub-text">
      {{ data.message }}
      <span> Delete </span> <span class="item-to-delete">{{ data.name }}</span
      >?
      <br />
      <span class="warning-text">This action cannot be undone.</span>
      <br />
    </span>
  </div>
  <div class="dialog-actions">
    <button mat-flat-button class="delete-btn" (click)="delete()">
      Delete
    </button>
    <button mat-stroked-button (click)="cancel()">Cancel</button>
  </div>
</div>
